import * as Sentry from '@sentry/nuxt'

import { version } from './package.json'

import { useRuntimeConfig } from '#imports'

Sentry.init({
  dsn: useRuntimeConfig().public.sentryDsn,
  release: version,
})
